module.exports = __webpack_public_path__ + "static/img/0006-A-01.51fce45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/audioimg/0006-A-01.jpg
// module id = vCSq
// module chunks = 0